/**
 * 对象转query参数
 */
export const formatQuery = (data: Record<string, any>) => {
  return Object.keys(data)
    .reduce((total, key) => {
      if (data[key]) {
        total.push(`${key}=${data[key]}`)
      }
      return total
    }, [] as string[])
    .join('&')
}
